import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AgGridComponent } from 'src/app/shared/common-components/ag-grid/ag-grid.component';
import { AgGridI, PaginationModel } from 'src/app/shared/common-components/ag-grid/ag-grid.model';
import { AgGridService } from 'src/app/shared/common-components/ag-grid/ag-grid.service';
import { StorageName } from 'src/app/shared/enum/common-enum';
import { StorageService } from 'src/app/shared/services/storage.service';
import { AgGridDataModelPassbookTab, InstallmentEntryModel, GetResponsEntryModel, InsertNormaltabData, AgGridDataModelColDefsPartyLog, AgGridDataModelNormalTab, InstallmentEntries } from '.././././././././installment-entry/installment-entry.model';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { CommonService } from 'src/app/shared/services/common.service';
import { GridOptions, GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import { commonModalOptionsLg } from 'src/app/shared/models/common.model';
import { ReceiptPopupComponent } from './receipt-popup/receipt-popup.component';
import { InvestmentFundService } from '../investment-fund.services';
import { DatePipe } from '@angular/common';
import { InstallmentType } from '../investment-fund.model';
import { SendDataService } from 'src/app/shared/services/send-data.service';
import { LoadDropdownDataComponent } from 'src/app/shared/common-components/load-dropdown-data/load-dropdown-data.component';
import { CustomSelect2Component } from 'src/app/shared/common-components/custom-select2/custom-select2.component';
import { CustomerDetailsComponent } from 'src/app/shared/common-components/common-voucher/popup/customer-details/customer-details.component';
import { ModalPopupSize, VoucherType } from '../../../../shared/models/common.model';
import { NotificationService } from '../../../../shared/services/notification.service';
import { CreateSchemeComponent } from '../create-scheme/create-scheme.component';
import { SundryType } from '../../../../shared/common-components/common-voucher/popup/customer-details/customer-details.model';
import { Router } from '@angular/router';
import { TransactionService } from '../../transaction.service';
import { ReportService } from '../../../report/report.service';
import { SelectPrintFormatPopupComponent } from '../../../../shared/common-components/common-voucher/popup/select-print-format-popup/select-print-format-popup.component';

@Component({
  selector: 'app-installment-entry',
  templateUrl: './installment-entry.component.html',
  styleUrls: ['./installment-entry.component.scss'],
  providers: [DatePipe]
})
export class InstallmentEntryComponent extends CommonService implements OnInit, OnDestroy {
  @ViewChild("installmentEntry") InstallmentEntryForm!: NgForm;
  @ViewChild(LoadDropdownDataComponent) loadDropdownDataComponent: LoadDropdownDataComponent;
  @ViewChild(CustomSelect2Component) customSelect2Component: CustomSelect2Component;
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>;
  formName = StorageName.FORMNAME_TRANSACTION_INVESTMENT_LAYAWAYS_FUND;
  hasAttemptedSubmit: boolean = false;
  @ViewChild('contents', { static: true }) contents!: TemplateRef<any>;
  @Output() sendDataToChild: EventEmitter<boolean> = new EventEmitter();
  @Output() dataAndRowEmitter = new EventEmitter<{ data: any, amount:number,fundTransferId:number, fundWithdrawId:number }>();
  @Output() dataEmitter: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("layawaysDropdown") layawaysDropdown: CustomSelect2Component;
  formModel: any = {};
  agGridDataModelInstallmentEntry: AgGridI;
  agGridDataModelAddEntry: AgGridI;
  agGridDataModelNormal: AgGridI
  onDeleteRowClickedSubscription: Subscription;
  private textClickSubscriptionForTab: Subscription;
  cardPaymentClickIconSubscription: Subscription;
  getAllDropdownModel: any = {};
  storageName = StorageName;
  installmentFundPartyList: any;
  getallRequstModel = new PaginationModel();
  gridApiInstallmentEntryList: any;
  isaddDetails: boolean = false;
  getDataModel: any = {};
  fundentriesInsertModel: any = {};
  generetRowData: any;
  installmentEntryModel = new InstallmentEntryModel();
  getResponsEntryModel = new GetResponsEntryModel();
  insertNormaltabData = new InsertNormaltabData();
  schemeID: any;
  gridApi: any;
  machurityDate: any
  machurityWeekDate: any;
  machurityMonthDate: any;
  machurtityYearDate: any;
  @Input() gridDynamicHeightClasses: string = 'h-300px';
  imageUrl = "../../../assets/SVGicon/profile-img.svg";
  activeTabId = InstallmentEntries.Normal;
  isTab2Enabled: boolean;
  gridApis: any;
  sundryType = SundryType;
  columnApi: any
  customerAddress
  selectedLedgerData: any;
  @Input() layawaysData                        : any;
  @Input() invoiceDetailId: any;
  fillFromlayaways: boolean;
  installmentEntries = InstallmentEntries;
  rdlcResourceName: any = "";
  notificationConfigurationModel : any = [];
  paymentMasterId: any;
  constructor(
    public storageService: StorageService,
    public renderer: Renderer2,
    public agGridService: AgGridService,
    private modalService: NgbModal,
    public toaster: ToastrService,
    private investmentFundService: InvestmentFundService,
    public notificationService : NotificationService,
    private sendDataService: SendDataService,
    private datePipe: DatePipe,
    private router: Router,
    public transactionService: TransactionService,
    public reportService:ReportService
  ) {
    super(renderer);
  }

  onCardPaymentIconClick(params:any)
  {
    this.openReceiptPopup(params?.detail?.data);
  }
  onDeleteIconClick(params:any){
    let result:any
    if (params)
      result = params?.detail?.data;
      this.deleteInstallmentFundEntries(result?.data?.paymentMasterId,result);
  }
  ngOnInit(): void {
    this.agGridDataModelAddEntry = AgGridDataModelPassbookTab
    this.agGridDataModelInstallmentEntry = AgGridDataModelColDefsPartyLog;
    this.agGridDataModelNormal = AgGridDataModelNormalTab;
    this.onTabChange(1)
    this.sendDataService.displayPageName(this.formName);
    this.moreButtonDisabled();
    this.fillDropdownData();
  }

  handleTextClick(event) {
    const data = event?.data;
    if(event?.colDef?.field =='accountLedgerName' || event?.colDef?.field =='invoiceNo' )
      this.cellClicked(data)
      if(event?.colDef?.field=='accountLedgerName')
        this.selectedLedgerData =data
  }


  // for party data
  onGridProdutListReady(event: any) {
    this.installmentFundPartyList = event;
    this.getallPartyData();
  }

  //for installment party data
  getallPartyData() {
    this.showLoading(this.installmentFundPartyList);
    this.getallRequstModel.getAll = true;
    this.investmentFundService.GetallinstallmentfunddetailsData(this.getallRequstModel).subscribe({
      next: (res) => {
        if (res?.isSuccess) {
          this.installmentFundPartyList?.api?.setRowData(res?.response?.data);
          let partiesData = res?.response?.data;
          this.storageService.store(StorageName.INVESTMENT_FUND_INSTALL_ENTRY_INITIAL_ROWS, partiesData);
          this.refreshGridApi();
          if (this.layawaysData || this.invoiceDetailId)
            this.fillFromlayaways = true;
          this.addDetails();
          if (this.layawaysData || this.invoiceDetailId)
            this.fillPartiesdata(this.layawaysData, partiesData ,this.invoiceDetailId)
        } else {
          this.hideLoading(this.installmentFundPartyList);
          this.installmentFundPartyList?.api?.setRowData([]);
        }
      }, error: (err) => {
        this.hideLoading(this.installmentFundPartyList);
        this.installmentFundPartyList?.api?.setRowData([]);
      }
    })
  }

  fillDropdownData() {
    this.getAllDropdownModel.accountLedgerDropdown = this.storageService.retrieve(StorageName.ACCOUNTLEDGER_DROPDOWN);
    this.getAllDropdownModel.salePersonDropdown = this.storageService.retrieve(StorageName.SALEPERSON_DROPDOWN);
    this.getAllDropdownModel.schemeNameDropdown = this.storageService.retrieve(StorageName.SCHEME_NAME_DROPDOWN);
    this.getAllDropdownModel.userDropdown = this.storageService.retrieve(StorageName.USER_DROPDOWN);
    setTimeout(() => {
      if(this.customSelect2Component)this.customSelect2Component.setDataSource(this.getAllDropdownModel?.accountLedgerDropdown);
    }, 5000);
  }
  onGridadreadyNormaltab(params) {
    this.gridApi = params?.api;
    this.columnApi = params?.columnApi;
    this.setIsPickupDone();
    this.checkOption(this.formModel?.footerCalculation?.paidInstallments)

  }
  onGridReady(gridApi) {
    this.gridApis = gridApi?.api;
    this.columnApi = gridApi?.columnApi;
    this.setIsPickupDone();
  }

  gridOptions: GridOptions = {
    suppressClickEdit: true,
    getRowStyle: this.getRowStyle,
  };

  onTabChange(nextId) {
    this.activeTabId = nextId;
    // this.cellClicked(this.getDataModel)
  }
  gridOptionsTaxSetting: GridOptions =
    {
      singleClickEdit: true,
      getRowStyle: this.getRowStyle,
    }

  getRowStyle(params: any) {
    return {
      background: params?.node?.rowIndex % 2 === 0 ? '#EEF1F7' : '#FFFFFF',
    };
  }

  deleteInstallmentFundEntries(id: number, params:any) {
    if(id){
    this.investmentFundService.DeleteInstallmentFundEntries(id).subscribe((res) => {
      if (res?.isSuccess) {
        this.toaster.success(res?.message);
        const newRowData = [{
          installmentDate: params?.data?.installmentDate, 
          paymentDate: '', 
          amount:params?.data?.amount, 
          goldRate: '', 
          goldWeight:'', 
          entryBy: ''
        }];
        this.replaceRowAtIndex(newRowData, params);
        this.getById(this.getDataModel)

      }else{
        this.getById(this.getDataModel)
      } 
    });
  }else {
    // const newRowData = [{
    //   installmentDate: params?.data?.installmentDate, 
    //   paymentDate: params?.data?.paymentDate, 
    //   amount: params?.data?.amount, 
    //   goldRate: params?.data?.goldRate, 
    //   goldWeight: params?.data?.goldWeight, 
    //   entryBy: params?.data?.entryBy
    // }];
   // this.replaceRowAtIndex1(newRowData, params);
   if(this.activeTabId==InstallmentEntries.Passbook){
    this.getById(this.getDataModel)
    this.toaster.error('Failed to delete the entry. The row has been restored.');
  }
  }
    
  }
  getFormattedAddress(fullAddress: string): string {
    if (!fullAddress) return '';
    return fullAddress.replace(/,/g, ', ').replace(/=/g, '= ');
}
  replaceRowAtIndex(newRowData: any, params: any) {
    if (this.formModel?.passbookList && this.formModel?.passbookList.length > params?.rowIndex) {
      this.formModel.passbookList[params.rowIndex] = newRowData[0]; 
      params?.api?.setRowData(this.formModel?.passbookList);
    } else {
      console.error(`Invalid row index: ${params?.rowIndex}. Unable to replace row.`);
    }
  }
  
  replaceRowAtIndex1(newRowData: any, rowIndex: number) {
    if (this.formModel?.passbookList && this.formModel?.passbookList.length > rowIndex) {
      this.formModel.passbookList[rowIndex] = newRowData;
    }
  }
  refreshGridApi() {
    this.gridApiInstallmentEntryList?.api.refreshHeader();
  }

  openReceiptPopup(param) {
    const shouldShowMonthDropdown = param?.colDef?.extraField === 'ActionPassbook' && !param?.data?.hasSamePaymentMasterId;
    const data = {
      showMonthDropdown: shouldShowMonthDropdown,
      monthDropdownList: this.formModel?.monthDropdownList,
      getDataModel     : param.data,
      entryByList      : this.getAllDropdownModel?.userDropdown,
      receiptAmount    : this.getDataModel?.installmentAmount,
      redemptionOn     : this.getDataModel?.redemptionOnName,
      ammount          : this.getDataModel?.installmentAmount,
      formModel: {
        goldRate         : this.getDataModel?.redemptionOnName === 'Amount' ? null : this.formModel?.currentGoldRate,
        installmentDate  : param?.data?.installmentDate,
        entryBy          : param?.data?.entryBy,
        amount           : this.getDataModel?.installmentAmount,
        schemeId         : this.schemeID,
        installmentFundId: this.getDataModel?.id,
        installmentFundInvoiceNo: this.getDataModel?.invoiceNo,
        accountLedgerId  : this.getDataModel?.accountLedgerId
      },
      monthList: this.formModel?.normalList?.map(x => x?.installmentDateInFormat)
    };
    this.notificationService.openModalPopup(ReceiptPopupComponent,data, '',ModalPopupSize.LG,'', false,true).then(
      (result) => {
      if (result) {
        this.cellClicked(this.getDataModel);
      }
    });
  }

  cellClicked(data) {
    this.formModel.footerCalculation = {
      paidInstallments: 0,
      paidAmount: 0,
      remainingAmount: 0,
      totalAmount: 0,
      goldWt: 0,
    };
    this.formModel.passbookList = [];
    this.schemeID = data?.schemeId;
    this.getDataModel = data;
    this.isTab2Enabled = false;
    this.checkPymentopetion(data?.id);
    if(this.gridApi.headerComponentParams){
      this.gridApi.headerComponentParams.isDisable = data?.id ? false : true;
      this.gridApi?.refreshHeader();
    }
    this.getById(data)
    setTimeout(() => {
      this.loadDropdownDataComponent?.setInvoiceNo(data?.invoiceNo);
    }, 200);
    
  }

  isFundTransferDisabled(): boolean {
    return this.formModel?.fundTransferId > 0;
  }
  
  isFundWithdrawDisabled(): boolean {
    return this.formModel?.fundWithdrawId > 0 && this.formModel?.fundTransferId === 0;
  }

  setIsPickupDone(){
    switch (this.activeTabId) {
      case InstallmentEntries.Passbook:
        this.gridApis.isPickupDone = this.getDataModel?.isPickupDone ||  this.selectedLedgerData?.isPickupDone;
        break;
      case InstallmentEntries.Normal:
        this.gridApi.isPickupDone = this.getDataModel?.isPickupDone ||  this.selectedLedgerData?.isPickupDone;
        break;;
    }
  }

  getById(data){
    this.setIsPickupDone();
    this.investmentFundService.getByIdmentfunddetailsData(data?.id, data?.schemeId).subscribe((res) => {
      if (res?.isSuccess) {
        this.formModel = res?.response;
        this.fillDropdownData();
        this.checkOption(this.formModel?.footerCalculation?.paidInstallments)
        const amount =res?.response?.footerCalculation?.paidAmount
        this.isaddDetails = false;
        this.sendDataToChild.emit(this.isaddDetails);
        this.dataAndRowEmitter.emit({ data, amount,fundTransferId: this.formModel?.fundTransferId, fundWithdrawId: this.formModel?.fundWithdrawId  });
        // this.passBookRowData.forEach(item => {
        //   if (item?.id) {
        //     this.checkPymentopetion(0);
        //   }
        // });
        if (this.formModel?.length > 0) {
          // this.generateRow(row,data)
        } else {
          this.generetRowData = [{ installmentDate: data?.joiningDate, paymentDate: '', amount: data?.installmentAmount, goldRate: '0.00', goldWeight: '0.000', entryBy: '' }];
          // this.generateRow(this.generetRowData,data)
        }
      }
    })

  }
  checkPymentopetion(id): void {
    const allColumns = this.columnApi?.getAllColumns();
    const lastColumn = allColumns[allColumns?.length - 1];
    const lastColDef = lastColumn?.getColDef();
    const colDefs = allColumns?.map(column => column?.getColDef());
    const shouldShowMoreButton = id ? true : false;
    this.gridApis?.setColumnDefs(colDefs?.map(colDef => {
      if (colDef?.cellRendererParams && colDef?.headerName == '') {
        colDef.cellRendererParams.Payment = shouldShowMoreButton;
        colDef.cellRendererParams.Delete = shouldShowMoreButton;
      }
      return colDef;
    }));
  }
  moreButtonDisabled(){
    this.agGridService.nextRowAdded.subscribe((event=>{
      if(event){
        if( this.activeTabId==InstallmentEntries.Normal){
          this.checkOption(this.formModel?.footerCalculation?.paidInstallments)
        }
      }
    }))
   }
  
   checkOption(id: string): void {
    if( this.activeTabId==InstallmentEntries.Normal){
    let extractedValue = id?.split('/')[1];
    let arrangedValue = `${extractedValue}/${extractedValue}`;
    const allColumns = this.columnApi?.getAllColumns();
    const colDefs = allColumns?.map(column => column?.getColDef());
    const shouldShowButton = this.formModel?.footerCalculation?.paidInstallments == arrangedValue ? true :false;
    const updatedColDefs = colDefs?.map(colDef => {
        if (colDef?.headerComponentParams && colDef?.headerName === '') {
            colDef.headerComponentParams.isDisable = shouldShowButton;
        }
        return colDef;
    });
    this.gridApi.setColumnDefs(updatedColDefs);
  }
}



  addDetails() {
    this.isaddDetails = true;
    this.sendDataToChild.emit(this.isaddDetails);
    if(!this.fillFromlayaways)
      this.loadDropdownDataComponent.getInvoiceNo();
    this.getDataModel = {};
    this.formModel.passbookList = [];
    this.generetRowData = [];
    this.formModel.normalList = [];
    this.installmentEntryModel = new InstallmentEntryModel();
    this.isTab2Enabled = true;
    this.activeTabId = InstallmentEntries.Normal;
    this.formModel.footerCalculation = {
      paidInstallments: 0,
      paidAmount: 0,
      remainingAmount: 0,
      totalAmount: 0,
      goldWt: 0,
    };
    this.getResponsEntryModel = new GetResponsEntryModel();
    this.machurityDate = '';
    this.installmentEntryModel.joiningDate = this.todayDate;
    this.customSelect2Component?.setDataSource(this.getAllDropdownModel?.accountLedgerDropdown , 0);
    this.customSelect2Component?.setDropdownText("");
    this.customSelect2Component?.reset();
    this.fillFromlayaways = false;
  }
  todayDate: Date
  selectedRangeDates(event) {

    this.installmentEntryModel.maturityDate = event;
  }

  getDataBuSchemeID(event) {
    const id = Number(event)
    this.investmentFundService.Getschemedetailbyid(id).subscribe((res) => {
      if (res?.isSuccess) {
        const data = res?.response;
        this.getResponsEntryModel = data;
        this.generetRowData = [{ installmentDate: this.installmentEntryModel.joiningDate, paymentDate: '', amount: data.installmentAmount, goldRate: '0.00', goldWeight: '0.000', entryBy: '' }];
        this.generateRow(this.generetRowData, data);
        this.machurityDate = this.addMonths(this.todayDate, this.getResponsEntryModel?.duration, this.getResponsEntryModel?.installmentTypeName, this.getResponsEntryModel?.durationTypeName);
        this.checkPymentopetion(0)
      }
    })
  }

  setAddressByAccountLedgerId(accountLedgerId) {
    const selectedLedger = this.getAllDropdownModel?.accountLedgerDropdown?.find(
      ledger => ledger?.id === accountLedgerId
    );
    if (selectedLedger && selectedLedger?.extra2) {
      this.customerAddress =  JSON?.parse(selectedLedger?.extra2)[0]?.fullAddress; 
    } else {
      this.customerAddress = ''; 
    }
  }
  
  selectedRangeDatesjoiningDate(event) {
    this.todayDate = event
    this.installmentEntryModel.joiningDate = event;
    if (this.getResponsEntryModel.duration) {
      this.machurityDate = this.addMonths(event, this.getResponsEntryModel?.duration, this.getResponsEntryModel?.installmentTypeName, this.getResponsEntryModel?.durationTypeName);
      this.generetRowData = [{ installmentDate: this.installmentEntryModel?.joiningDate, paymentDate: '', amount: this.getResponsEntryModel?.installmentAmount, goldRate: '0.00', goldWeight: '0.000', entryBy: '' }];
     // this.generateRow(this.generetRowData, this.getResponsEntryModel)
    }
  }


  addMonths(date: Date, months: number, type, durationTypeName) {
    const result = new Date(date);
    const days = new Date(result)
    if (type == InstallmentType.Daily) {
      this.machurityWeekDate = days.setDate(result.getDate() + months * 30);
      const formattedDate = this.datePipe?.transform(this.machurityWeekDate, 'dd-MM-yyyy');
      this.installmentEntryModel.maturityDate = this.datePipe?.transform(this.machurityWeekDate, 'yyyy-MM-ddTHH:mm:ss');
      return formattedDate;
    }

    if (type == InstallmentType.Weekly) {
      if (durationTypeName == 'Year') {
        // const weeksInMonth = 366 / 7 ;
        const daysInMonth = 365
        const fullWeeks = Math?.floor(daysInMonth / 7);
        this.totalWeeks = months * fullWeeks;
      }
      else {
        const weeksInMonth = 4.34524; // Average number of weeks in a month (52 / 12)
        const allweeks = Math?.ceil(months * weeksInMonth);
        this.totalWeeks = allweeks - 1
      }
      this.machurityWeekDate = new Date(date);
      this.machurityWeekDate = result?.setDate(result.getDate() + this.totalWeeks * 7);
      const formattedDate = this.datePipe?.transform(this.machurityWeekDate, 'dd-MM-yyyy');
      this.installmentEntryModel.maturityDate = this.datePipe?.transform(this.machurityWeekDate, 'yyyy-MM-ddTHH:mm:ss');
      return formattedDate;
    }
    if (type == InstallmentType.Monthly) {
      if (durationTypeName == 'Year') {
        // const weeksInMonth = 366 / 7 ;
        const allMonth = 12;
        this.totalWeeks = months * allMonth;
      }
      else {
        this.totalWeeks = months
      }
      this.machurityMonthDate = result?.setMonth(result.getMonth() + this.totalWeeks);
      const formattedDate = this.datePipe?.transform(this.machurityMonthDate, 'dd-MM-yyyy');
      this.installmentEntryModel.maturityDate = this.datePipe?.transform(this.machurityMonthDate, 'yyyy-MM-ddTHH:mm:ss');
      return formattedDate;
    }
    if (type == InstallmentType.Yearly) {
      this.machurtityYearDate = result?.setFullYear(result.getFullYear() + months);
      const formattedDate = this.datePipe?.transform(this.machurtityYearDate, 'dd-MM-yyyy');
      this.installmentEntryModel.maturityDate = this.datePipe?.transform(this.machurtityYearDate, 'yyyy-MM-ddTHH:mm:ss');
      return formattedDate;
    }
  }
  insertinstallmentfundData() {
    if (this.getAllDropdownModel?.salePersonDropdown?.length == 0) {
      this.installmentEntryModel.salePersonId = '0'
    }
    if (this.installmentEntryModel?.accountLedgerId && this.installmentEntryModel?.schemeId && this.installmentEntryModel?.joiningDate) {
      this.investmentFundService.InsertinstallmentfundData(this.installmentEntryModel).subscribe(res => {
        if (res?.isSuccess) {
          this.toaster.success(res?.message);
          this.installmentEntryModel = new InstallmentEntryModel();
          this.getResponsEntryModel = new GetResponsEntryModel();
          this.getallPartyData();
        }
      })
    } else {
      this.toaster.error('please select customer')
    }
  }

  selectDates(selectedDates: any): string {
    const startDate = selectedDates;
    const datePipe = new DatePipe('en-US');
    const todayDate = datePipe?.transform(startDate, 'yyyy-MM-ddTHH:mm:ss.SSS') || ''
    return todayDate;
  }

  openCustomerDetailsSlider(type: string, ledgerName: string = ''): void {
    const accountLedgerId = type === 'Edit' ? this.installmentEntryModel?.accountLedgerId : 0;
    const data = {
      accountLedgerId: accountLedgerId,
      SundryType: this.sundryType.SundryDebitor,
      ledgerName: ledgerName,
    };

    this.notificationService.openSlider(CustomerDetailsComponent, data).then(
      (result) => {
        if (result) {
          this.getAllDropdownModel.accountLedgerDropdown = this.storageService.retrieve(StorageName.ACCOUNTLEDGER_DROPDOWN);
          const newLedger = this.getAllDropdownModel?.accountLedgerDropdown?.filter((x) => x?.id === result.toString())[0];
          this.installmentEntryModel.accountLedgerId = newLedger?.id;
          this.customSelect2Component?.setDataSource(this.getAllDropdownModel?.accountLedgerDropdown, newLedger?.id);
        }
      });
  }
    
    
  generateRow(row: any, data: any) {
   let passBookRowData
    const lastRecord = row[row?.length - 1];
    const lastInstallmentDate = lastRecord.installmentDate
    switch (data.installmentTypeName) {
      case InstallmentType.Daily:
        passBookRowData = [...row, ...this.generateDailyData(lastInstallmentDate, data?.duration, row[0]?.amount, data?.durationTypeName)];
        this.calculationAmount(row, data, passBookRowData)
        break;
      case InstallmentType.Weekly:
        passBookRowData = [...row, ...this.generateWeeklyData(lastInstallmentDate, data?.duration, row[0]?.amount, data?.durationTypeName)];
        this.calculationAmount(row, data, passBookRowData)
        break;
      case InstallmentType.Monthly:
        passBookRowData = [...row, ...this.generateMonthData(lastInstallmentDate, data?.duration, row[0]?.amount, data?.durationTypeName)];
        this.calculationAmount(row, data, passBookRowData)
        break;
      case InstallmentType.Yearly:
        passBookRowData = [...row, ...this.generateYearData(lastInstallmentDate, data?.duration, row[0]?.amount)];
        this.calculationAmount(row, data, passBookRowData)
        break;
      default:
        this.formModel.passbookList = [];
    }
  }
  totalWeeks: number
  totalDays: number
  generateDailyData(startDateInput: Date, months: number, initialAmount: number, type) {
    const days = 30;
    this.totalDays = months * days;
    const data = [];
    let amount = initialAmount;
    for (let i = this.generetRowData?.length; i < this.totalDays; i++) {
      const startDate = new Date(startDateInput);
      const weekDate = new Date(startDate);
      weekDate.setDate(startDate.getDate() + i + 1);
      data.push({ installmentDate: weekDate.toDateString(), paymentDate: '', amount, goldRate: '', goldWeight: '', entryBy: '' }); // Increment amount logic
    }
    return data;
  }

  generateWeeklyData(startDate: Date, months: number, initialAmount: number, type) {
    if (type == 'Year') {
      // const weeksInMonth = 366 / 7 ;
      const daysInMonth = 366
      const fullWeeks = Math?.floor(daysInMonth / 7);
      this.totalWeeks = months * fullWeeks;
    } else {
      const weeksInMonth = 4.34524; // Average number of weeks in a month (52 / 12)
      this.totalWeeks = Math?.ceil(months * weeksInMonth);
    }
    const data = [];
    let amount = initialAmount;
    for (let i = this.generetRowData?.length; i < this.totalWeeks; i++) {
      const weekDate = new Date(startDate);
      weekDate.setDate(weekDate.getDate() + i * 7);
      data?.push({ installmentDate: weekDate.toDateString(), paymentDate: '', amount, goldRate: '', goldWeight: '', entryBy: '' }); // Increment amount logic
    }
    return data;
  }
  totalMonths
  generateMonthData(startDate: Date, months: number, initialAmount: number, type) {
    if (type == 'Year') {
      this.totalMonths = months * 12
    } else {
      this.totalMonths = months;
    }
    const data = [];
    let amount = initialAmount;
    for (let i = this.generetRowData?.length; i < this.totalMonths; i++) {
      const weekDate = new Date(startDate);
      weekDate?.setMonth(weekDate.getMonth() + i);
      data?.push({ installmentDate: weekDate.toDateString(), paymentDate: '', amount, goldRate: '', goldWeight: '', entryBy: '' }); // Increment amount logic
    }
    return data;
  }

  generateYearData(startDate: Date, months: number, initialAmount: number) {
    const totalMonth = months;
    const data = [];
    let amount = initialAmount;
    for (let i = this.generetRowData?.length; i < totalMonth; i++) {
      const weekDate = new Date(startDate);
      weekDate?.setFullYear(weekDate.getFullYear() + i);
      data?.push({ installmentDate: weekDate.toDateString(), paymentDate: '', amount, goldRate: '', goldWeight: '', entryBy: '' }); // Increment amount logic
    }
    return data;
  }
totalAmountCalculation(row, data, row1){
  this.formModel.footerCalculation.totalAmount = ((row1?.length > 0) ? row1?.length : 1) * data?.installmentAmount;
}
  calculationAmount(row, data, row1) {
    this.totalAmountCalculation(row, data, row1)
    // let paidinstRow = row1.filter(a => a.paymentDate != '')
    // this.paidInstallment = paidinstRow?.length
    // let numbers = this.passBookRowData.filter(a => a.paymentDate != '' ? a.amount : 0);
    // let paidAmt = numbers.map(b => b.amount);
    // let finalPaidAmt: any = paidAmt.reduce((acc, value) => acc + value, 0);
    // this.paidAmount = finalPaidAmt.toFixed(2);
    // let amt = row[0]?.amount;
    // const totalAMt: any = amt * this.paidInstallment;
    // this.totalAmount = totalAMt.toFixed(2)
    // let remainingAmount = this.totalAmount - this.paidAmount;

    // this.remainingAmt = remainingAmount.toFixed(2)
    // let goldWeight = this.passBookRowData.map(a => a.goldWeight);
    // this.goldWt = goldWeight.reduce((acc, value) => acc + value, 0);
  }
  assignAccountProductId(event) {

  }
  checkPresentInLedgerList(ledgerName){
    if(ledgerName){
      this.openCustomerDetailsSlider('Add' ,ledgerName)
    }
    else
    {
      let element = document.getElementById('salesPersonDropdown') as any;
      element?.focus();
      element?.showPicker();
    }
 }

  OpenCreateUpdateSchemeSlider() {
    const data = {
      schemeType: 'Create',
    };
    this.notificationService.openSlider(CreateSchemeComponent, data).then(
      (result) => {
        if (result) {
          this.agGridService?.getDropdownByStorageName(StorageName.SCHEME_NAME_DROPDOWN).subscribe({
            next: (res) => {
              this.getAllDropdownModel.schemeNameDropdown = res?.response ?? [];
              this.storageService.store(StorageName.SCHEME_NAME_DROPDOWN, this.getAllDropdownModel?.schemeNameDropdown);
              if (this.getAllDropdownModel?.schemeNameDropdown?.length) this.layawaysDropdown?.setDataSource(this.getAllDropdownModel?.schemeNameDropdown);
            }
          });
        }
      })
  }
  
  openConfirmationPopup() {
    this.notificationService.confirmationPopup(
      'Update layaway status',
      'Do you want to update the layaway status?',
      'pickup'
    ).subscribe((result) => {
      if (result.isConfirmed) {
        this.updateLayawaysStatus();
      }
    });

  }

  updateLayawaysStatus() {
    const requestData = { id: this.selectedLedgerData?.againstVoucherNo, voucherTypeId: this.selectedLedgerData?.againstVoucherTypeId }
    this.investmentFundService.updatelayawaysstatus(requestData).subscribe({
      next: (res) => {
        this.toaster.success(res?.message);
        this.selectedLedgerData.isPickupDone = true;
        this.setIsPickupDone();
      },
      error: (err) => {

      }
    });
  }

  reFillData(){
    this.cellClicked(this.getDataModel);
  }

  fillPartiesdata(layawaysdata, partiesdata, invoiceDetailId) {
    const data = partiesdata?.find(x => invoiceDetailId ? x?.id === invoiceDetailId : x?.invoiceNo === layawaysdata?.invoiceNo);
    this.selectedLedgerData = data;
    this.cellClicked(data);
  }
  

  navigateToagainstInvoiceNo() {
    switch (this.selectedLedgerData?.againstVoucherTypeId) {
      case VoucherType.SalesInvoice:
        this.storageService.store("SaleInvoiceId", this.selectedLedgerData?.againstVoucherNo);
        this.router.navigate(['transaction/saleinvoice']);
        break;
      case VoucherType.SalesQuotation:
        this.storageService.store(StorageName.STORED_TRANSACTION_SALESQUOTATION_ID, this.selectedLedgerData?.againstVoucherNo);
        this.router.navigate(['transaction/estimate']);
        break;
    }
  }

  printButtonClick(event) {
    this.paymentMasterId= event?.detail?.data?.data.paymentMasterId;
    this.loadDropdownDataComponent.confirmPrintPopUp();
  }

  onPrint(isPrint) {
    this.formModel.isPrint = isPrint;
    this.formModel.invoiceModel ={};
    this.formModel.invoiceModel.sendNotification = true;
    this.formModel.invoiceModel.voucherTypeId = VoucherType.ReceiptVoucher;
    this.processToInsertInvoiceData();
    
  }

  processToInsertInvoiceData() {
    this.transactionService.getSettingsAndRDLCTemplate(this.formModel?.isPrint, null, VoucherType.ReceiptVoucher, (printFormatData) => {
      if (printFormatData) {
        this.openSelectPrintFormatPopup(printFormatData);
      } else {

        this.reportService.processResponse({ response: this.paymentMasterId }, this.formModel?.invoiceModel, this.notificationConfigurationModel, this.formModel?.isPrint, undefined, this.rdlcResourceName, true)

      }
    });
  }
  
  openSelectPrintFormatPopup(printFormatData: any) {
    var data = { printFormatData: printFormatData, modalTitle: 'Select Print Format' }
    this.notificationService.openModalPopup(SelectPrintFormatPopupComponent, data, undefined, ModalPopupSize.MD, '', false, true).then(
      (result) => {
        if (result) {
          const componentInstance = result;
          this.rdlcResourceName = componentInstance;
          this.selectedLedgerData
          this.reportService.processResponse({ response: this.paymentMasterId }, this.formModel?.invoiceModel, this.notificationConfigurationModel, this.formModel?.isPrint, undefined, this.rdlcResourceName, true)
        }
      }
    )
  }

  
  ngOnDestroy(): void
  {
    this.onDeleteRowClickedSubscription?.unsubscribe();
    this.cardPaymentClickIconSubscription?.unsubscribe();
    this.layawaysData = [];
    this.invoiceDetailId=undefined;
    // this.sendDataService?.headerPageNameAndInvoiceNum?.next(undefined);
  }
}